$(() => {
  const pluginName = 'emailShare';
  const organizationName = 'raceRoster';
  const eventNamespace = `${organizationName}.${pluginName}`;

  /**
   * Returns the number of recipients
   * @param data
   * @returns {*}
   */
  const getRecipientCount = (data) => data.elements.$recipientList
    .children(data.settings.selectors.recipient)
    .length;

  /**
   * Executes the callback provided by the user
   * @param callback
   * @param parameters
   */
  const executeCallback = (callback = null, parameters = null) => {
    if (callback && typeof callback === 'function') {
      if (parameters && parameters.constructor === Array && parameters.length) {
        callback(...parameters);
      } else {
        callback();
      }
    }
  };

  /**
   * If the number of recipients is >= than the maximum number of recipients, disable the button
   * @param data
   */
  const toggleAddRecipient = (data) => {
    data.elements.$addRecipient
      .prop('disabled', getRecipientCount(data) >= data.settings.maximumRecipients);
  };

  /**
   * Add a recipient!
   * @param data
   */
  const addRecipient = (data) => {
    const $lastRecipient = data.elements.$recipientList
      .children(data.settings.selectors.recipient)
      .last();
    const index = $lastRecipient.length
      ? parseInt($lastRecipient.data('recipient-index'), 10) + 1
      : 0;
    const $recipient = $(data.properties.recipientPrototype.replace(/__recipientIndex__/g, index));

    data.elements.$recipientList.append($recipient);
    $recipient.find('.js-email-share-recipient-name').focus();
    toggleAddRecipient(data);
  };

  /**
   * Just kidding remove that recipient
   * @param data
   * @param event
   */
  const removeRecipient = (data, event) => {
    $(event.target).closest(data.settings.selectors.recipient).remove();
    toggleAddRecipient(data);

    if (getRecipientCount(data) >= data.settings.maximumRecipients) {
      data.elements.$send.focus();
    } else {
      data.elements.$addRecipient.focus();
    }
  };

  /**
   * Focuses the message input and selects all the text in it
   * @param data
   */
  const focusMessage = (data) => {
    data.elements.$message.focus();
    data.elements.$message[0].select();
  };

  /**
   * Tries its best to send the email out
   * @param data
   */
  const send = (data) => {
    $.ajax({
      url: data.elements.$form.attr('action'),
      type: 'post',
      data: data.elements.$form.serialize(),
    })
      .done(() => {
        if (data.settings.i18n.sent) {
          data.elements.$snackBar.snackBar('add', {
            type: 'success',
            icon: 'check',
            content: data.settings.i18n.sent,
          });
        }

        data.elements.$form[0].reset();
        focusMessage(data);
        executeCallback(data.settings.callbacks.sent, [data]);
        data.elements.$element.trigger(data.settings.events.sent);
      })
      .fail((response) => {
        data.elements.$snackBar.snackBar('add', {
          type: 'danger',
          icon: 'exclamation-circle',
          content: response.responseText,
        });
      })
      .always(() => {
        data.elements.$form.googleRecaptcha('reattach');
        data.elements.$form.trigger('raceRoster.preventDoubleSubmission.reEnable');
      });
  };

  /**
   * Gets all the elements we care about
   * @param $element
   * @param settings
   * @returns {object}
   */
  const getElements = ($element, settings) => ({
    $element,
    $form: $element.find(settings.selectors.form),
    $message: $element.find(settings.selectors.message),
    $recipientList: $element.find(settings.selectors.recipientList),
    $addRecipient: $element.find(settings.selectors.addRecipient),
    $send: $element.find(settings.selectors.send),
    $snackBar: $('[data-js-snack-bar]'),
  });

  $.fn[pluginName] = function Plugin(options) {
    /**
       * Fire up
       * @param index
       * @param element
       */
    const initialize = (index, element) => {
      const $element = $(element);

      if ($element.data(pluginName)) {
        return;
      }

      if (!('googleRecaptcha' in $.fn)) {
        $.error('This plugin depends on the Google RECAPTCHA plugin.');
        return;
      }

      const settings = $.extend(true, {}, $.fn[pluginName].defaults, options);
      const elements = getElements($element, settings);
      const properties = {
        recipientPrototype: elements.$recipientList.data('recipient-prototype'),
      };
      const data = {
        settings,
        elements,
        properties,
      };

      $element.data(pluginName, data);
      $element.on('shown.bs.modal', () => {
        focusMessage(data);
        $.fn.googleRecaptcha.fire();
      });
      $element
        .on('click', settings.selectors.removeRecipient, (event) => removeRecipient(data, event));
      elements.$addRecipient.on('click', () => addRecipient(data));
      elements.$form.googleRecaptcha({
        badge: 'inline',
        callbacks: {
          success: () => {
            send(data);
          },
          error: () => {
            data.elements.$form.trigger('raceRoster.preventDoubleSubmission.reEnable');
          },
        },
      });
    };

    return this.each(initialize);
  };

  $.fn[pluginName].defaults = {
    url: null,
    selectors: {
      form: '.js-email-share-form',
      message: '.js-email-share-message',
      recipientList: '.js-email-share-recipient-list',
      recipient: '.js-email-share-recipient',
      addRecipient: '.js-email-share-add-recipient',
      removeRecipient: '.js-email-share-remove-recipient',
      send: '.js-email-share-send',
    },
    maximumRecipients: 10,
    i18n: {
      sent: null,
    },
    callbacks: {
      sent: () => {},
    },
    events: {
      sent: `${eventNamespace}.sent`,
    },
  };
});
